module.exports = __webpack_public_path__ + "static/media/PDF_77.29eee7f3.pdf";